import { memo } from "react";
import { format } from "date-fns";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { fullDateFormatWithTime } from "@common/helpers/date";
import { timeAgo } from "@helpers/date";
import cellStyles from "@components/history/views/cells/Cell.module.scss";
import { OrganizationActivityRow } from "../organizationActivityRow";

export const CreatedAtCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationActivityRow, unknown>) => {
        const date = new Date(row.original.date);
        const relativeTime = timeAgo(date);
        const exactDate = format(date, fullDateFormatWithTime);

        return (
            <ViewTableCell className={cellStyles.dateCell}>
                <Tooltip content={exactDate}>
                    <span>{relativeTime}</span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);

CreatedAtCell.displayName = "CreatedAtCell";
